/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UserRoleMembership model module.
 * @module model/UserRoleMembership
 * @version V1
 */
class UserRoleMembership {
    /**
     * Constructs a new <code>UserRoleMembership</code>.
     * @alias module:model/UserRoleMembership
     */
    constructor() { 
        
        UserRoleMembership.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UserRoleMembership</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserRoleMembership} obj Optional instance to populate.
     * @return {module:model/UserRoleMembership} The populated <code>UserRoleMembership</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserRoleMembership();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('roleId')) {
                obj['roleId'] = ApiClient.convertToType(data['roleId'], 'Number');
            }
            if (data.hasOwnProperty('userId')) {
                obj['userId'] = ApiClient.convertToType(data['userId'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UserRoleMembership</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UserRoleMembership</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} id
 */
UserRoleMembership.prototype['id'] = undefined;

/**
 * @member {Number} roleId
 */
UserRoleMembership.prototype['roleId'] = undefined;

/**
 * @member {Number} userId
 */
UserRoleMembership.prototype['userId'] = undefined;






export default UserRoleMembership;

